/*
 * rf-gclid-capture.js — Google-Ads-Attribution-Capture (RepairFirst)
 *
 * Erfasst die Klick-IDs (gclid/gbraid/wbraid) + UTM aus der Landing-URL (First-Touch,
 * über den mehrstufigen Globo-Anfrage-Funnel hinweg per localStorage) und schreibt sie
 * — zusammen mit der bereits vom CMP (Avada Consent Mode v2) erfassten Einwilligung —
 * als CART-ATTRIBUTE via /cart/update.js. Shopify überträgt Cart-Attribute auf die
 * Order als note_attributes; das Intranet liest sie server-seitig (lib/tracking/capture.ts)
 * und speist daraus die Offline-Conversion-Pipeline (gads_gclid + order_consents).
 *
 * Globo-UNABHÄNGIG: lauscht nur auf Standard-Events, fasst Globo nicht an.
 * Empirisch verifiziert: Cart-Attribute überleben Add-to-Cart + /pages/danke-Redirect.
 * Consent-Quelle = EINE (das CMP) — keine zweite Checkbox (siehe Spec §10 / N4).
 */
(function () {
  'use strict';
  var LS = '_rf_click';
  var LS_OUTREACH = '_rf_outreach';
  var DECIDED = '_rf_consent_decided'; // wird NUR beim visitorConsentCollected-Event gesetzt
  var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  // First-Touch-Capture der Klick-IDs aus der URL (überschreibt einen früheren Klick NICHT).
  function capture() {
    try {
      var p = new URLSearchParams(location.search);
      if (!CLICK_KEYS.some(function (k) { return p.get(k); })) return;
      var cur = {};
      try { cur = JSON.parse(localStorage.getItem(LS) || '{}'); } catch (e) { cur = {}; }
      if (cur._ts) return; // First-Touch gewinnt
      CLICK_KEYS.forEach(function (k) { var v = p.get(k); if (v) cur[k] = v; });
      cur._ts = new Date().toISOString();
      localStorage.setItem(LS, JSON.stringify(cur));
    } catch (e) { /* no-op */ }
  }

  // Direct-Mail-Outreach kommt über die persönliche Shopify-Theme-Seite und
  // /discount/CODE?redirect=…-Route. Die drei anonymen Parameter werden als
  // eigenes Last-Explicit-Touch gespeichert: ein bewusst geöffneter neuer Flyer
  // darf eine ältere Outreach-Aktion ersetzen, während GAds oben First-Touch bleibt.
  function storeOutreach(context) {
    try {
      var campaign = context && context.campaign || '';
      var attribution = context && context.attribution || '';
      var entrypoint = context && context.entrypoint || '';
      if (!/^[a-z0-9][a-z0-9-]{0,63}$/.test(campaign)) return false;
      if (!/^[A-Za-z0-9_-]{24,80}$/.test(attribution)) return false;
      if (entrypoint !== 'qr' && entrypoint !== 'purl') return false;
      localStorage.setItem(LS_OUTREACH, JSON.stringify({
        campaign: campaign,
        attribution: attribution,
        entrypoint: entrypoint,
        _ts: new Date().toISOString()
      }));
      return true;
    } catch (e) { return false; }
  }

  function captureOutreach() {
    try {
      var p = new URLSearchParams(location.search);
      storeOutreach({
        campaign: p.get('rf_campaign') || '',
        attribution: p.get('rf_attribution') || '',
        entrypoint: p.get('rf_entrypoint') || ''
      });
    } catch (e) { /* no-op */ }
  }

  // Die Customer-Privacy-API ist NICHT automatisch auf der Seite. Ohne expliziten
  // loadFeatures-Aufruf ist window.Shopify.customerPrivacy undefined, und consentSignal()
  // liefert strukturell 'unspecified' — unabhängig davon, was der Besucher entschieden hat.
  // Das war die Ursache dafür, dass 0 von 223 Aufträgen mit Klick-ID je eine Einwilligung
  // trugen (verifiziert am Live-Shop 2026-07-29). Deshalb: erst laden, dann lesen.
  function withConsentApi(cb) {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.currentVisitorConsent === 'function') { cb(); return; }
    // loadFeatures ist beim ersten Aufruf oft nur ein Queue-Stub, der den Callback
    // erst ausführt, wenn Shopifys load_feature-Skript nachlädt. Bleibt das aus,
    // käme cb() nie — und ohne Notausgang würde auch die Klick-ID nicht geschrieben.
    var erledigt = false;
    function einmal() { if (erledigt) return; erledigt = true; cb(); }
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], einmal);
        setTimeout(einmal, 3000);
        return;
      }
    } catch (e) { /* no-op */ }
    einmal(); // Fallback: ohne API weiter — consentSignal() liefert dann 'unspecified'
  }

  // Einwilligung aus dem CMP lesen (Shopify Customer Privacy / Consent Mode v2).
  // marketing-Consent → ad_user_data + ad_personalization. Unentschieden → 'unspecified' (fail-closed).
  function consentSignal() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.currentVisitorConsent !== 'function') return 'unspecified';
      var c = cp.currentVisitorConsent();
      if (c && c.marketing === 'yes') return 'granted';
      // 'no' bedeutet bei Shopify BEIDES: aktiv abgelehnt und noch nicht gefragt.
      // shouldShowBanner() taugt nicht zur Unterscheidung — es bleibt auch nach
      // erteilter Zustimmung true (am Live-Shop verifiziert 2026-07-29). Deshalb
      // eine eigene Markierung, die ausschliesslich beim Entscheidungs-Event gesetzt
      // wird: ohne Markierung ist 'no' ein Default und kein Nein des Besuchers.
      if (c && c.marketing === 'no') {
        try { return localStorage.getItem(DECIDED) === '1' ? 'denied' : 'unspecified'; }
        catch (e) { return 'unspecified'; }
      }
    } catch (e) { /* no-op */ }
    return 'unspecified';
  }

  // Cart-Attribute setzen (nur wenn es etwas zu attribuieren gibt).
  function sync() {
    var s = {};
    var outreach = {};
    try { s = JSON.parse(localStorage.getItem(LS) || '{}'); } catch (e) { s = {}; }
    try { outreach = JSON.parse(localStorage.getItem(LS_OUTREACH) || '{}'); } catch (e) { outreach = {}; }
    var co = consentSignal();
    var hasClick = !!(s.gclid || s.gbraid || s.wbraid || s.utm_source);
    var hasOutreach = !!(outreach.campaign && outreach.attribution && outreach.entrypoint);
    if (!hasClick && !hasOutreach && co === 'unspecified') return; // nichts zu schreiben

    // NUR gefüllte Felder senden. Shopify wertet einen Leerstring als LÖSCHEN des
    // Attributs — ein Sync ohne localStorage-Daten (iOS/ITP löscht ihn nach 7 Tagen,
    // der Cart-Cookie überlebt) würde sonst eine früher erfasste Klick-ID aus dem
    // Warenkorb entfernen. Genau dadurch schließen sich Klick-ID und erteilte
    // Einwilligung in der Produktion fast vollständig aus: derselbe POST, der die
    // Einwilligung schreibt, löscht die Klick-ID.
    var attrs = {};
    function put(key, value) { if (value) attrs[key] = value; }
    put('_rf_gclid', s.gclid);
    put('_rf_gbraid', s.gbraid);
    put('_rf_wbraid', s.wbraid);
    put('_rf_utm_source', s.utm_source);
    put('_rf_utm_medium', s.utm_medium);
    put('_rf_utm_campaign', s.utm_campaign);
    put('_rf_first_click_ts', s._ts);
    put('_rf_outreach_campaign', outreach.campaign);
    put('_rf_outreach_attribution', outreach.attribution);
    put('_rf_outreach_entrypoint', outreach.entrypoint);

    // Einwilligung nie herabstufen: ein bereits geschriebenes 'granted'/'denied' darf
    // nicht beim nächsten Seitenaufruf wieder auf 'unspecified' zurückfallen.
    if (co !== 'unspecified') {
      attrs._rf_consent_ad_user_data = co;
      attrs._rf_consent_ad_personalization = co;
      attrs._rf_consent_source = 'cmp';
      attrs._rf_consent_text_version = 'v1';
    }

    // Nichts Belastbares dabei → auch keinen Request absetzen.
    var hatInhalt = false;
    for (var k in attrs) { if (Object.prototype.hasOwnProperty.call(attrs, k)) { hatInhalt = true; break; } }
    if (!hatInhalt) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { /* no-op */ });
  }

  // Jeder Auslöser läuft über withConsentApi, damit die Consent-API geladen ist,
  // BEVOR consentSignal() sie liest — sonst bleibt der Wert immer 'unspecified'.
  function syncWithApi() { withConsentApi(sync); }

  capture();
  captureOutreach();

  // (1) Wenn der Besucher die Consent-Entscheidung trifft (Shopify-Event) → Entscheidung
  //     markieren (macht 'no' erst zu einem echten Nein) und Attribute aktualisieren.
  document.addEventListener('visitorConsentCollected', function () {
    try { localStorage.setItem(DECIDED, '1'); } catch (e) { /* no-op */ }
    syncWithApi();
  });

  // Die feste Shopify-Outreach-Seite löst den opaken URL-Token über das Portal
  // auf und liefert den anonymen Kontext anschließend über dieses Theme-Event.
  document.addEventListener('rf:outreach-context', function (event) {
    if (storeOutreach(event && event.detail || {})) syncWithApi();
  });

  // (2) Beim Add-to-Cart (Globo-Submit feuert das Theme-Event cart:item-add) → Attribute setzen.
  try {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartItemAdd) {
      window.subscribe(window.PUB_SUB_EVENTS.cartItemAdd, syncWithApi);
    }
  } catch (e) { /* no-op */ }

  // (3) Initialer Sync (setzt Klick-IDs früh; greift auch ohne Theme-pubsub).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWithApi);
  } else {
    syncWithApi();
  }
})();
